import { API } from 'constants/api';

const accountName = 'trendtech';
const serviceRoot = 'voximplant.com';

export function getURI(userID: string) {
    return `${userID}@${API.VOX_APP_NAME}.${accountName}.${serviceRoot}`;
}
